module.exports = __webpack_public_path__ + "static/media/YF83_3.29811cc2.jpg";